import { Icon, Card as INCard, Text } from "@innovationnorway/lighthouse-components";
import cn from "clsx";
import * as React from "react";
import "./card.scss";

export type CardProps = {
  role?: "hero" | "sidekick";
  variant?: "primary" | "secondary" | "tertiary";
  title: string;
  headingLevel?: "small" | "base" | "paragraph" | "subheading" | "lead1" | "lead2";
  url?: string;
  lead?: string;
  icon?: { prefix: ["prefix"]; name: string };
  onClick?: () => void;
} & React.HTMLAttributes<HTMLDivElement>;

const Card = React.forwardRef<HTMLDivElement, CardProps>(
  (
    {
      // eslint-disable-next-line react/prop-types
      className,
      variant = "secondary",
      title,
      headingLevel = "lead1",
      url,
      lead,
      icon,
      role = "hero",
      onClick,
      ...props
    },
    ref
  ) => {
    return (
      <INCard
        variant={variant}
        className={cn("in-card-action", `in-card-action--${variant}`, `in-card--${role}`)}
        onClick={onClick}
        style={{ cursor: "pointer" }}
      >
        <div ref={ref} {...props} className="in-card-action__content">
          <div className="in-card-action__text-container">
            <Text className="in-card-action__heading" variant={headingLevel}>
              {title}
            </Text>
            {lead && <div className="in-card-action__lead">{lead}</div>}
          </div>

          <div className="in-card-action__action-icon-container">
            <div />
            <Icon className="in-card-action__action-icon" prefix="fasr" iconName="arrow-right" size="s" />
          </div>
        </div>
      </INCard>
    );
  }
);

Card.displayName = "Card";

export { Card };
